import React from "react";
import {
    SovosButton,
    SovosDialog,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
    SovosTypography,
} from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

export const StagingRejectAllFixesModal = ({
    busy = false,
    onCancel,
    onConfirm,
    open,
}) => {
    const { i18n } = useGlobalValue();

    return (
        <SovosDialog fullWidth maxWidth="xs" onClose={onCancel} open={open}>
            <SovosDialogTitle onClose={onCancel} showCloseButton>
                {i18n`Reject all Auto fix`}
            </SovosDialogTitle>
            <SovosDialogContent>
                <SovosTypography color="text.secondary" variant="body2">
                    {i18n`Rejecting all auto fix`}
                </SovosTypography>
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton disabled={busy} onClick={onCancel} variant="text">
                    {i18n`Cancel`}
                </SovosButton>
                <SovosButton
                    color="primary"
                    disabled={busy}
                    onClick={onConfirm}
                    variant="contained"
                >
                    {i18n`Reject all`}
                </SovosButton>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export const StagingAcceptAllFixesModal = ({
    autoFixCount = 0,
    busy = false,
    onAcceptAll,
    onAcceptAllAndSaveRules,
    onCancel,
    open,
    ruleCount = 0,
}) => {
    const { i18n } = useGlobalValue();
    const autoFixLabel = autoFixCount === 1 ? i18n`auto fix` : i18n`auto fixes`;
    const ruleLabel = ruleCount === 1 ? i18n`SQL rule` : i18n`SQL rules`;

    return (
        <SovosDialog fullWidth maxWidth="sm" onClose={onCancel} open={open}>
            <SovosDialogTitle onClose={onCancel} showCloseButton>
                {i18n`Accept all Auto fix`}
            </SovosDialogTitle>
            <SovosDialogContent>
                {ruleCount > 0 ? (
                    <SovosTypography color="text.secondary" variant="body2">
                        {i18n`There`}
                        {" "}
                        <SovosTypography component="span" fontWeight={700} variant="body2">
                            {autoFixCount} {autoFixLabel}
                        </SovosTypography>
                        {" "}
                        {i18n`and`}
                        {" "}
                        <SovosTypography component="span" fontWeight={700} variant="body2">
                            {ruleCount} {ruleLabel}
                        </SovosTypography>
                        {" "}
                        {i18n`related. Would you like to save the rules as well? Next time the same error will be pre fixed by rule.`}
                    </SovosTypography>
                ) : (
                    <SovosTypography color="text.secondary" variant="body2">
                        {i18n`There`}
                        {" "}
                        <SovosTypography component="span" fontWeight={700} variant="body2">
                            {autoFixCount} {autoFixLabel}
                        </SovosTypography>
                        {" "}
                        {i18n`to apply.`}
                    </SovosTypography>
                )}
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton disabled={busy} onClick={onCancel} variant="text">
                    {i18n`Cancel`}
                </SovosButton>
                <SovosButton disabled={busy} onClick={onAcceptAll} variant="outlined">
                    {i18n`Accept all`}
                </SovosButton>
                {ruleCount > 0 && (
                    <SovosButton
                        color="primary"
                        disabled={busy}
                        onClick={onAcceptAllAndSaveRules}
                        variant="contained"
                    >
                        {i18n`Accept all and save rules`}
                    </SovosButton>
                )}
            </SovosDialogActions>
        </SovosDialog>
    );
};
